export default {
  config: 'Settings',
  history: 'Billing history',
  balance: 'Balance',
  chargeBalance: 'Recharge balance',
  main: 'Main',
  addPaymentMethod: 'Add payment method',
  addPaymentMethodConsumptions: '🤩 Add a payment method',
  paymentInfo: 'Payment info',
  billing: 'Billing',
  billingMail: 'Billing email address',
  SENT: 'Sent',
  PENDING: 'Pending',
  FAILED: 'Failed',
  PAID: 'Paid',
  service: 'Service',
  groupDescription: 'This are the items to invoice',
  nextPayment: 'Next payment',
  monthCompsumption: 'Montly usage',
  inviteFincancial: 'Invite users',
  downloadXls: 'Download .XLS',
  usage: 'Usage',
  payment: 'Payment',
  emailReport: 'Report emails',
  smsReport: 'Report SMS',
  loadingData: 'Loading records...',
  noData: 'No records found',
  rejected: 'Rejected',
  approve: 'Approved',
  withoutStatus: 'No status',
  channel: 'Channel',
  sentFrom: 'Sent at',
  sentTo: 'Sent to',
  itemSent: 'Sent',
  delivered: 'Delivered',
  open: 'Open',
  rebound: 'Bounced',
  creationDate: 'Creation date',
  exportRegisters: 'Export records',
  registersExported: 'Records exported',
  chargeBalanceModalTitle: 'Recharge the balance you need',
  chargeBalanceModalDescription: 'You can recharge anytime',
  howMuch: '¿How much do you want to recharge?',
  rememberUSD: '*Recharge is in USD',
  whichCard: '¿How do you want to pay',
  balanceCharged: '¡Your credit was added successfully!',
  balanceChargedMessage: 'Keep using Keybe and increase your sales',
  newBalance: 'New balance',
  setAsMain: 'Set as main',
  quantityDiscount: 'Discount',
  USDDiscount: 'Discount in USD',
  totalDiscount: 'Total discount',
  discountPercentage: 'Discount %',
  discountAmount: 'Discount amount',
  total: 'Total',
  showDetails: 'Show details',
  hideDetails: 'Hide details',
  subtotal: 'Subtotal',
  cutDate: 'Closing date',
  details: 'Details',
  totals: 'Totals',
  addANewCard: 'Add a new card',
  addCard: 'Add card',
  errorUpdatingPlan: 'Error updating plan',
  errorCopying: 'Error copying',
  inviteAdministrators: 'Invite users',
  addInvitesEmail: 'Add the emails of the persons you want to invite',
  sendInvitations: 'Send invitations',
  invalidEmailAddress: 'Invalid email address',
  noEmailToInvite: 'No emails to invite',
  invitationSent: 'Invitation sent',
  amountMustBeOverTen: 'Amount must be greater than 10',
  paymentMethod: 'Payment method',
  // CONSUMPTIONS ENGLISH
  consumptions: 'Charge Types',
  message_whatsapp: 'Whatsapp Messages',
  message_instagram: 'Instagram Messages',
  message_sms_col: 'SMS Messages',
  message_email: 'Email Messages',
  message_bot: 'Bot Messages',
  message_bot_api: 'Bot Api Call',
  message_web: 'Web Messages',
  message_messenger: 'Facebook Message',
  wa_session_business_col: 'Bussiness Sesions',
  daily_contact: 'Daily Chat',
  premium_plan_base_price: 'Plan Premium',
  professional_plan_base_price: 'Plan Professional',
  ai_room_sentiment: 'Sentiment Analysis',
  wa_session_user_col: 'User Sessions',
  professional_license: 'Professional License',
  user_license: 'Users Licenses',
  line_license: 'Line License',
  actions_triggers: 'Triggers',
  itsTime: 'It`s time to ',
  toTopUpBalance: 'top up the balance!',
  menuButtonConsumption: 'Usage',
  consumptionTitle: 'Usage details',
  consumptionAmount: 'Total daily amount',

  consumptionBalance: 'Balance $USD',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  last2Month: 'Last 2 month',
  last3Month: 'Last 3 month',

  typeCharge: 'Billing',
  typeAmount: 'Amount',

  chartPieTitle: 'Balance USD',

  consumptionItem: 'Billiing Item',
  consumptionDate: 'Date',
  consumptionAmountItem: 'Amount',
  consumptionPlan: 'Plan',
  consumptionUnit: 'Unit Price',
  consumptionSubTotal: 'Sub Total',
  consumptionTotal: 'Total Price',
  consumptionDiscount: 'Discount',

  tabConsumptions: 'Usage',
  tabInvoices: 'Invoices',
  invoicesTitle: 'Invoices Details',

  bactive: 'Active',
  binactive: 'Inactive',

  reasonTitle: 'Inactive Reasons',
  holdReason: 'Reason:',
  holdDate: 'Date:',
  payments: 'Payments',
  bhistory: 'History',
  ingressDate: 'Ingress Date',
  payDate: 'Pay Date',
  billingKB: 'Billing KB'
}
